<template>
    <div
        :class="{
            'c-header__search js-header-search': true,
            'is-form-visible': isFormVisible,
            'is-open': isOpen,
        }"
    >
        <div class="c-search">
            <LuigisAutocompleteForm
                ref="autocompleteForm"
                :autocompleteUrl="autocompleteUrl"
                :isFormVisible="isFormVisible"
                :isOpen="isOpen"
                :inputPlaceholder="inputPlaceholder"
                v-model="keyword"
                @show-form="showForm"
                @hide-form="hideForm"
                @searched="setMatches"
            />
        </div>

        <button class="c-btn c-btn--header" @click="showForm">
            <i class="ico ico-shadow-search"><i class="path1"></i><i class="path2"></i></i>
            <span>{{ $t('Autocomplete.Header.label') }}</span>
        </button>
    </div>
</template>

<script>
import { checkResolution } from '../../tools/helpers';
import RshopAutocomplete from "./../../../../vendor/rshop/frontend/assets/js/components/Autocomplete";
import { showHeaderOverlay, hideHeaderOverlay } from '../../tools/overlay';
import LuigisAutocompleteForm from './LuigisAutocompleteForm';

export default {
    extends: RshopAutocomplete,
    props: {
        luigisBoxPublicKey: {
            type: String,
            required: true,
        },
        texts: {
            type: Object,
            required: true,
        },
    },
    components: {
        LuigisAutocompleteForm: LuigisAutocompleteForm,
    },
    data() {
        return {
            isFormVisible: false,
            luigisBoxInstance: null,
        };
    },
    mounted() {
        // Guard: use the exact input element from our form, not a global selector
        const inputEl = this.$refs?.autocompleteForm?.$refs?.searchInput;
        if (!inputEl) return;

        // Prevent double-initialization (e.g., when extending RshopAutocomplete or when the component remounts)
        if (inputEl.dataset.lbxInited === '1' || this.luigisBoxInstance) {
            return;
        }

        const initIfReady = () => {
            if (typeof AutoComplete !== 'undefined') {
                this.initLuigisBox();
            } else {
                setTimeout(initIfReady, 100);
            }
        };

        initIfReady();
    },
    beforeDestroy() {
        const inputEl = this.$refs?.autocompleteForm?.$refs?.searchInput;
        if (this?.luigisBoxInstance?.$IsOpen) {
            this.luigisBoxInstance.Close();
        }
        this.luigisBoxInstance = null;
        if (inputEl && inputEl.dataset) {
            delete inputEl.dataset.lbxInited;
        }
    },
    computed: {
        inputPlaceholder() {
            return checkResolution('cxs') ? this.$t('Autocomplete.Header.placeholderMobile') : this.$t('Autocomplete.Header.placeholder')
        }
    },
    methods: {
        initLuigisBox() {
            const vueThis = this
            const luigisBoxInstance = AutoComplete({
                Layout: 'heromobile',
                TrackerId: this.luigisBoxPublicKey,
                Locale: 'sk',
                Translations: {
                    sk: {
                        placeholderText: this.texts.placeholder,
                        types: {
                            product: {
                                name: this.texts.product,
                                heroName: this.texts.topProduct,
                                recommendName: this.texts.recommendProduct,
                                recommendHeroName: this.texts.recommendTopProduct,
                            },
                            promotion: {
                                name: this.texts.promotion,
                                recommendName: this.texts.recommendedPromotion,
                            },
                            category: {
                                name: this.texts.category,
                                recommendName: this.texts.recommendedCategory,
                            },
                            manufacturer: {
                                name: this.texts.manufacturer,
                                recommendName: this.texts.recommendedManufacturer,
                            },
                            brand: {
                                name: this.texts.brand,
                                recommendName: this.texts.recommendedBrand,
                            },
                            article: {
                                name: this.texts.article,
                                recommendName: this.texts.recommendedArticle,
                            },
                            query: {
                                name: this.texts.query,
                            },
                        },
                    }
                },
                Types: [
                    {
                      type: 'product',
                      size: 7,
                      attributes: ['custom_contents', 'custom_ribbon_text'],
                      recommend: {
                        size: 7
                      }
                    },
                    {
                        type: 'promotion',
                        size: 3,
                        recommend: {
                            size: 3
                        }
                    },
                    {
                        type: 'category',
                        size: 3,
                        recommend: {
                            size: 3
                        }
                    },
                    {
                        type: 'manufacturer',
                        size: 3,
                        recommend: {
                            size: 3
                        }
                    },
                    {
                        type: 'brand',
                        size: 3,
                        recommend: {
                            size: 3
                        }
                    },
                    {
                        type: 'article',
                        size: 3,
                        recommend: {
                            size: 3
                        }
                    },
                    {
                        type: 'query',
                        size: 5,
                    },
                ],
                FormatForDisplay(result) {
                    if (!Eshop.options.pricesWithVat) return result

                    if (result.type === 'product') {
                        result.attributes.price = result.attributes.price_vat
                        result.attributes.price_amount = result.attributes.price_amount_vat

                        if (result.attributes.price_old_vat) {
                            result.attributes.price_old = result.attributes.price_old_vat
                            result.attributes.price_old_amount = result.attributes.price_old_vat_amount
                        }

                        if (result.attributes.custom_ribbon_text == "Zľava" && result.attributes.discount_price_vat_percentage_amount > 0) {
                            result.attributes.custom_ribbon_text = `-${Math.round(result.attributes.discount_price_vat_percentage_amount)}%`
                        }

                    }

                    return result;
                },
                Actions: [
                    {
                        forRow: function(row) {
                            if (row.type !== 'product') {
                                return false;
                            }

                            return row.attributes.availability !== 0;
                        },
                        iconUrl: '/img/icons/cart.svg',
                        title: 'Do košíka',
                        action: function(e, result) {
                            e.preventDefault();

                            $.post(`${Eshop.options.baseUrl}add-item/${result.attributes.id[0]}`, function (response) {
                                Cart.callbacks.addedItem(null, response);
                                rEvent.dispatch('Cart.product.after_add', response);
                            }.bind(this), 'json');
                        }
                    }
                ],
                BeforeOpen() {
                    if (vueThis.isFormVisible) {
                        return
                    }

                    vueThis.showForm()
                },
                AfterClose() {
                    const searchInputEl = vueThis.$refs.autocompleteForm.$refs.searchInput

                    if (document.activeElement !== searchInputEl) {
                        vueThis.hideForm()
                    }
                },
            }, this.$refs.autocompleteForm.$refs.searchInput)

            this.luigisBoxInstance = luigisBoxInstance[0]
            this.$refs.autocompleteForm.$refs.searchInput.dataset.lbxInited = '1'

            // Inject custom element into Luigi's Box autocomplete
            this.injectCustomElement()
        },
        injectCustomElement() {
            const vueThis = this

            const createSearchIcon = () => {
                const customDiv = document.createElement('span')
                customDiv.className = 'ico ico-search js-search is-search luigi-ac-heromobile-input-clear'

                // Add click event to trigger search submission
                customDiv.addEventListener('click', () => {
                    // Call the redirectToSearch method from LuigisAutocompleteForm
                    if (vueThis.$refs?.autocompleteForm?.redirectToSearch) {
                        vueThis.$refs.autocompleteForm.redirectToSearch()
                    }
                })

                return customDiv
            }

            // Use MutationObserver to wait for Luigi's Box to render
            const observer = new MutationObserver(() => {
                const inputWrap = document.querySelector('.luigi-ac-heromobile-input-wrap')

                if (inputWrap && !inputWrap.querySelector('.js-search')) {
                    const customDiv = createSearchIcon()
                    inputWrap.appendChild(customDiv)
                    observer.disconnect()
                }
            })

            // Start observing the document body for changes
            observer.observe(document.body, {
                childList: true,
                subtree: true
            })

            // Also try to inject immediately in case the element already exists
            setTimeout(() => {
                const inputWrap = document.querySelector('.luigi-ac-heromobile-input-wrap')
                if (inputWrap && !inputWrap.querySelector('.js-search')) {
                    const customDiv = createSearchIcon()
                    inputWrap.appendChild(customDiv)
                    observer.disconnect()
                }
            }, 100)

            // Override mobile tabs behavior to show all content at once
            this.overrideMobileTabs()

            // Handle query clicks
            this.handleQueryClicks()

            // Clean up broken attributes periodically
            this.startCleanup()
        },
        startCleanup() {
            // Clean up immediately
            this.cleanTitles()

            // Then clean up periodically
            this.cleanupInterval = setInterval(() => {
                this.cleanTitles()
            }, 100)
        },
        cleanTitles() {
            // Clean up broken HTML in luigi-ac-attrs (if in ribbon is icon for example)
            document.querySelectorAll('.luigi-ac-attrs').forEach(el => {
                // Remove all broken attributes
                Array.from(el.attributes).forEach(attr => {
                    el.removeAttribute(attr.name)
                })

                // Remove everything except .luigi-ac-attr spans
                Array.from(el.childNodes).forEach(node => {
                    // Keep only .luigi-ac-attr spans
                    if (node.nodeType === 1 && node.classList && node.classList.contains('luigi-ac-attr')) {
                        // Keep this node
                        return
                    }
                    // Remove everything else (text nodes, ico elements, etc.)
                    node.remove()
                })
            })
        },
        handleQueryClicks() {
            // Simple click handler for query suggestions
            document.addEventListener('click', (e) => {
                const queryItem = e.target.closest('.luigi-ac-item[data-autocomplete-is-query="1"]')
                if (queryItem) {
                    e.preventDefault()
                    e.stopPropagation()

                    const queryValue = queryItem.getAttribute('data-autocomplete-value')
                    if (queryValue) {
                        window.location.href = `/vyhladavanie?search=${encodeURIComponent(queryValue)}`
                    }
                }
            })
        },
        overrideMobileTabs() {
            // Use MutationObserver to wait for Luigi's Box autocomplete to render
            const observer = new MutationObserver(() => {
                const luigiInner = document.querySelector('.luigi-ac-inner')

                if (luigiInner) {
                    // Remove click handlers from tab switches to prevent hiding content
                    this.disableTabSwitching()

                    // Show all content sections
                    this.showAllContentSections()

                    observer.disconnect()
                }
            })

            observer.observe(document.body, {
                childList: true,
                subtree: true
            })

            // Also try immediately in case content already exists
            setTimeout(() => {
                const luigiInner = document.querySelector('.luigi-ac-inner')
                if (luigiInner) {
                    this.disableTabSwitching()
                    this.showAllContentSections()
                    observer.disconnect()
                }
            }, 200)
        },
        disableTabSwitching() {
            // Remove click handlers from tab switches
            const switches = document.querySelectorAll('.luigi-ac-heromobile-switch')
            switches.forEach(switchEl => {
                const newSwitch = switchEl.cloneNode(true)
                switchEl.parentNode?.replaceChild(newSwitch, switchEl)
            })
        },
        showAllContentSections() {
            // Check if we're on mobile (matching the @media query in SCSS)
            const isMobile = checkResolution('cxs;xs')

            if (!isMobile) {
                // On mobile: Remove inline display styles to let CSS handle display properties
                // This allows CSS rules like 'display: contents !important' and 'display: flex !important' to work
                const sections = document.querySelectorAll('.luigi-ac-others, .luigi-ac-products, .luigi-ac-main')
                sections.forEach(section => {
                    section.style.removeProperty('display')
                })

                // Remove inline display styles from items to let CSS handle them
                const items = document.querySelectorAll('.luigi-ac-item, .luigi-ac-header')
                items.forEach(item => {
                    item.style.removeProperty('display')
                })
            } else {
                // On desktop: Keep the original behavior - force show with display: block
                const sections = document.querySelectorAll('.luigi-ac-others, .luigi-ac-products, .luigi-ac-main')
                sections.forEach(section => {
                    section.style.display = 'block'
                })

                const items = document.querySelectorAll('.luigi-ac-item, .luigi-ac-header')
                items.forEach(item => {
                    item.style.display = 'block'
                })
            }
        },
        showForm() {
            this.isFormVisible = true
        },
        hideForm() {
            if (this?.luigisBoxInstance?.$IsOpen) {
                this.luigisBoxInstance.Close()
            }

            this.isFormVisible = false
        },
        handleClickOutside($event) {
            if (
                !this.$el.contains($event.target)
                && !$event.target.closest('.swal2-container')
                && !$event.target.closest('.notify')
                && !$event.target.closest('.luigi-ac')
                && !$event.target.closest('[data-tippy-root]')
                && (this.isOpen && this.isFormVisible)
            ) {
                this.isOpen = false;
                this.isFormVisible = false;
                this.selectedIndex = -1;

                this.$el.dispatchEvent(new CustomEvent("autocompleteHide"));

                if (typeof window.rEvent.dispatch === 'function') {
                    window.rEvent.dispatch("Autocomplete.hide");
                }
            }
        },
    },
    watch: {
        isFormVisible(value) {
            const navigationEl = document.querySelector('.js-navigation')

            if (navigationEl) {
                navigationEl.classList.toggle('is-autocomplete-visible', value)
            }

            if (value) {
                showHeaderOverlay('autocomplete')
            } else {
                hideHeaderOverlay('autocomplete')
            }
        }
    }
};
</script>
